(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const initializeHero = (hero) => {
    if (hero.dataset.luxuryReady === 'true') return;
    hero.dataset.luxuryReady = 'true';

    const slides = Array.from(hero.querySelectorAll('[data-luxury-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-luxury-dot]'));
    if (slides.length < 2) return;

    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let intervalId;
    const delay = Number(hero.dataset.autoplayDelay || 6) * 1000;

    const showSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === activeIndex));
      dots.forEach((dot, index) => dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false'));
    };

    const stop = () => window.clearInterval(intervalId);
    const start = () => {
      stop();
      if (hero.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        intervalId = window.setInterval(() => showSlide(activeIndex + 1), delay);
      }
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showSlide(index);
        start();
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    start();
  };

  const initializeTabs = (section) => {
    if (section.dataset.luxuryReady === 'true') return;
    section.dataset.luxuryReady = 'true';

    const tabs = Array.from(section.querySelectorAll('[data-luxury-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-luxury-panel]'));
    if (tabs.length < 2) return;

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item, itemIndex) => item.setAttribute('aria-selected', itemIndex === index ? 'true' : 'false'));
        panels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === index));
      });
    });
  };

  const initializeStickyPurchase = () => {
    const productRoot = document.querySelector('main[data-template="product"] product-info');
    const submitButton = productRoot?.querySelector('.product-form__submit');
    const title = productRoot?.querySelector('.product__title h1');
    const price = productRoot?.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale');
    if (!productRoot || !submitButton || !title || document.querySelector('[data-luxury-sticky-purchase]')) return;

    const sticky = document.createElement('div');
    sticky.className = 'luxury-mobile-purchase';
    sticky.dataset.luxuryStickyPurchase = '';
    sticky.innerHTML = `
      <div class="luxury-mobile-purchase__meta">
        <span class="luxury-mobile-purchase__title"></span>
        <span class="luxury-mobile-purchase__price"></span>
      </div>
      <button class="luxury-mobile-purchase__button" type="button"></button>
    `;
    document.body.appendChild(sticky);

    const stickyTitle = sticky.querySelector('.luxury-mobile-purchase__title');
    const stickyPrice = sticky.querySelector('.luxury-mobile-purchase__price');
    const stickyButton = sticky.querySelector('.luxury-mobile-purchase__button');
    const sync = () => {
      stickyTitle.textContent = title.textContent.trim();
      stickyPrice.textContent = price?.textContent.trim() || '';
      stickyButton.textContent = submitButton.textContent.trim();
      stickyButton.disabled = submitButton.disabled;
    };

    sync();
    const mutations = new MutationObserver(sync);
    mutations.observe(submitButton, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
    if (price) mutations.observe(price, { subtree: true, childList: true, characterData: true });

    stickyButton.addEventListener('click', () => submitButton.click());

    const buttonObserver = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY < productRoot.offsetTop + productRoot.offsetHeight);
    }, { threshold: 0.15 });
    buttonObserver.observe(submitButton);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-luxury-hero]').forEach(initializeHero);
    scope.querySelectorAll('[data-luxury-tabs]').forEach(initializeTabs);
    initializeStickyPurchase();
  };

  ready(() => {
    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  });
})();


/* Desktop mega menu: open on hover, retain keyboard support. */
(() => {
  const setupHoverMenus = (scope = document) => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    scope.querySelectorAll('.header__inline-menu details.mega-menu').forEach((menu) => {
      if (menu.dataset.hoverMegaReady === 'true') return;
      menu.dataset.hoverMegaReady = 'true';
      let closeTimer;
      const open = () => {
        window.clearTimeout(closeTimer);
        document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((item) => {
          if (item !== menu) item.removeAttribute('open');
        });
        menu.setAttribute('open', '');
      };
      const close = () => {
        closeTimer = window.setTimeout(() => menu.removeAttribute('open'), 140);
      };
      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', close);
      menu.addEventListener('focusin', open);
      menu.addEventListener('focusout', (event) => {
        if (!menu.contains(event.relatedTarget)) close();
      });
    });
  };
  const boot = () => setupHoverMenus(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => setupHoverMenus(event.target));
})();


(() => {
  const normal = value => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  const colorMap = new Map();
  String(document.body.dataset.rsCustomSwatches || '').split(/\r?\n/).forEach(line => {
    const match = line.match(/^\s*(.+?)\s*[:：]\s*(#[0-9a-f]{6}|#[0-9a-f]{3})\s*$/i);
    if (match) colorMap.set(normal(match[1]), match[2]);
  });
  const colorOptionNames = new Set(String(document.body.dataset.rsColorOptionNames || '').split(/[,，\n]/).map(normal).filter(Boolean));
  const isColorOption = value => colorOptionNames.has(normal(value)) || /colou?r|颜色|色号/.test(normal(value));
  const desktop = () => window.matchMedia('(min-width: 990px)').matches;
  const paintCardSwatches = (scope) => {
  const cards = Array.from(scope.querySelectorAll('.luxury-card-swatch'));
  if (scope.matches?.('.luxury-card-swatch')) cards.unshift(scope);
  cards.forEach((card) => {
    const swatch = card.querySelector('.swatch');
    if (!swatch) return;
    const color = swatch.style.getPropertyValue('--swatch--background') || colorMap.get(normal(card.title));
    if (color) swatch.style.setProperty('--rs-swatch', color);
    else {
      swatch.classList.add('rs-text-swatch');
      swatch.textContent = card.title;
    }
  });
};
let cardObserver;
const boot = () => {
  paintCardSwatches(document);
  const main = document.getElementById('MainContent');
  if (main && !cardObserver) {
    cardObserver = new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) paintCardSwatches(node);
      }));
    });
    cardObserver.observe(main, { childList: true, subtree: true });
  }
  document.querySelectorAll('.rs-product').forEach(setup);
};

  function setup(root) {
    if (root.dataset.rsReady) return;
    root.dataset.rsReady = 'true';
    const config = JSON.parse(root.querySelector('[data-rs-product-data]')?.textContent || '{}');
    let queued = false;
    let observer;
    const galleryBound = new WeakSet();
    const headerHeight = () => document.querySelector('.section-header')?.getBoundingClientRect().height || 0;

    function syncGallery() {
      const gallery = root.querySelector('media-gallery');
      if (!gallery) return;
      if (!galleryBound.has(gallery)) {
        galleryBound.add(gallery);
        gallery.addEventListener('scroll', event => {
          if (!event.target.matches?.('.product__media-list') || desktop()) return;
          const list = event.target;
          const visible = Array.from(list.children).filter(item => !item.classList.contains('rs-media-hidden'));
          const current = visible.reduce((closest, item) => Math.abs(item.offsetLeft - list.scrollLeft) < Math.abs(closest.offsetLeft - list.scrollLeft) ? item : closest, visible[0]);
          gallery.querySelectorAll('.rs-mobile-pagination button').forEach(button => button.setAttribute('aria-current', String(button.dataset.target === current?.dataset.mediaId)));
        }, { passive: true, capture: true });
      }
      let pagination = gallery.querySelector('.rs-mobile-pagination');
      if (!pagination) {
        pagination = document.createElement('nav');
        pagination.className = 'rs-mobile-pagination';
        pagination.setAttribute('aria-label', 'Product media');
        gallery.append(pagination);
      }
      const visible = Array.from(gallery.querySelectorAll('.product__media-item:not(.rs-media-hidden)'));
      const mediaIds = visible.map(item => item.dataset.mediaId).join(',');
      if (pagination.dataset.rsMediaIds !== mediaIds) {
        pagination.dataset.rsMediaIds = mediaIds;
        pagination.replaceChildren(...visible.map((item, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.target = item.dataset.mediaId;
          button.setAttribute('aria-label', 'View media ' + (index + 1) + ' of ' + visible.length);
          button.setAttribute('aria-current', String(index === 0));
          button.addEventListener('click', () => {
            const target = gallery.querySelector('[data-media-id="' + button.dataset.target + '"]');
            if (target) gallery.querySelector('.product__media-list')?.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          });
          return button;
        }));
      }
    }

    function sync() {
      observer?.disconnect();
      addDescriptionVideo();
      const description = root.querySelector('.luxury-product-description__content');
      const preview = root.querySelector('.luxury-product-description__preview');
      const paragraph = Array.from(description?.querySelectorAll('p') || []).find(node => !node.closest('table') && node.textContent.trim().length > 80);
      if (preview && paragraph && preview.textContent.trim() !== paragraph.textContent.trim()) preview.textContent = paragraph.textContent.trim();
      const info = root.querySelector('.product__info-container');
      const variants = info?.querySelector('variant-selects');
      if (variants) {
        const fields = Array.from(variants.querySelectorAll('fieldset'));
        const colorField = fields.find(f => Array.from(f.querySelectorAll('input')).some(i => isColorOption(i.dataset.optionName || '')));
        const sizeField = fields.find(f => Array.from(f.querySelectorAll('input')).some(i => /size/i.test(i.dataset.optionName || '')));
        if (colorField) {
          colorField.classList.add('luxury-color-swatches');
          const selected = colorField.querySelector('input:checked');
          const legend = colorField.querySelector('legend');
          const expected = `${selected?.dataset.optionName || 'Color'}: ${selected?.value || ''}`;
          if (legend && legend.textContent.trim() !== expected) legend.textContent = expected;
          colorField.querySelectorAll('input').forEach(input => {
            const label = Array.from(colorField.querySelectorAll('label')).find(l => l.htmlFor === input.id);
            const nativeSwatch = label?.querySelector('.swatch');
            const color = nativeSwatch?.style.getPropertyValue('--swatch--background') || input.dataset.rsSwatch || colorMap.get(normal(input.value));
            if (label && color) label.style.setProperty('--rs-swatch', color);
            else if (label) label.style.removeProperty('--rs-swatch');
            label?.classList.toggle('rs-text-swatch', !color);
            if (label) label.title = input.value;
          });

        }
        if (sizeField) sizeField.classList.add('luxury-size-field');
      }
      syncGallery();
      const submit = info?.querySelector('.product-form__submit');
      const price = info?.querySelector('.price--on-sale .price-item--sale') || info?.querySelector('.price-item--regular');
      const availability = info?.querySelector('[data-rs-availability]');
      if (submit && price && !submit.disabled) {
        const label = submit.querySelector('span');
        const text = `${config.addToBag} · ${price.textContent.trim()}`;
        if (label && label.textContent.trim() !== text) label.textContent = text;
      }
      if (availability && submit) availability.textContent = submit.disabled ? config.soldOut : config.inStock;
      root.style.setProperty('--rs-header-height', `${headerHeight()}px`);
      if (info) {
        root.style.setProperty('--rs-info-top', `${Math.min(headerHeight() + 24, window.innerHeight - info.offsetHeight - 24)}px`);
        const title = info.querySelector('.product__title');
        root.style.setProperty('--rs-rating-top', `${(title?.offsetHeight || 0) + 18}px`);
      }
      const sticky = document.querySelector('[data-luxury-sticky-purchase]');
      if (sticky && info) {
        const price = info.querySelector('.price--on-sale .price-item--sale') || info.querySelector('.price-item--regular');
        const submit = info.querySelector('.product-form__submit');
        const stickyPrice = sticky.querySelector('.luxury-mobile-purchase__price');
        const stickyButton = sticky.querySelector('button');
        if (stickyPrice && price) stickyPrice.textContent = price.textContent.trim();
        if (stickyButton && submit) { stickyButton.textContent = submit.textContent.trim(); stickyButton.disabled = submit.disabled; }
      }
      observer?.observe(root, { childList: true, subtree: true });
    }
    function queue() { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; sync(); }); }

    observer = new MutationObserver(queue);
    root.addEventListener('change', queue);
    root.addEventListener('click', event => {
      const thumb = event.target.closest('.thumbnail-list__item button');
      if (!thumb || !desktop()) return;
      event.preventDefault(); event.stopImmediatePropagation();
      const id = thumb.closest('[data-target]').dataset.target;
      const item = Array.from(root.querySelectorAll('.product__media-item')).find(e => e.dataset.mediaId === id);
      item?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      root.querySelectorAll('.thumbnail[aria-current]').forEach(b => b.removeAttribute('aria-current'));
      thumb.setAttribute('aria-current', 'true');
    }, true);
    function addDescriptionVideo() {
      const source = root.querySelector('.luxury-product-description__content iframe[src*="youtube.com/embed/"], .luxury-product-description__content iframe[src*="player.vimeo.com/video/"]');
      const list = root.querySelector('.product__media-list');
      if (!source || !list || list.querySelector('video, .rs-gallery-video')) return;
      const id = `${root.dataset.section}-description-video`;
      const item = document.createElement('li');
      item.className = 'product__media-item grid__item slider__slide rs-gallery-video';
      item.dataset.mediaId = id; item.id = `Slide-${id}`;
      const frame = source.cloneNode(true);
      frame.removeAttribute('style'); frame.loading = 'lazy'; frame.title = config.videoLabel;
      const url = new URL(frame.src); url.searchParams.set('controls', '1'); url.searchParams.set('rel', '0');
      frame.src = url.href; item.append(frame); list.append(item);
      const thumbnails = root.querySelector('.thumbnail-list');
      const first = thumbnails?.querySelector('li');
      if (first && !Array.from(thumbnails.children).some(thumb => thumb.dataset.target === id)) {
        const thumb = first.cloneNode(true); thumb.id = `Thumbnail-${id}`; thumb.dataset.target = id;
        const button = thumb.querySelector('button'); button.removeAttribute('aria-current'); button.removeAttribute('aria-describedby'); button.setAttribute('aria-label', config.videoLabel);
        thumb.querySelector('img')?.removeAttribute('id');
        const play = root.querySelector('template[data-rs-play]'); if (play) thumb.append(play.content.cloneNode(true));
        thumbnails.append(thumb);
      }
      root.querySelector('[id^="GalleryViewer-"]')?.resetPages?.();
    }
    addDescriptionVideo();
    const mediaObserver = new IntersectionObserver(entries => {
      const entry = entries.filter(e => e.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!entry || !desktop()) return;
      const id = entry.target.dataset.mediaId;
      const thumb = root.querySelector(`[data-target="${id}"] button`);
      if (!thumb) return;
      root.querySelectorAll('.thumbnail[aria-current]').forEach(b => b.removeAttribute('aria-current'));
      thumb.setAttribute('aria-current', 'true');
      const list = root.querySelector('.thumbnail-list');
      if (list) {
        const item = thumb.closest('li');
        const itemRect = item.getBoundingClientRect();
        const listRect = list.getBoundingClientRect();
        if (itemRect.top < listRect.top || itemRect.bottom > listRect.bottom) {
          list.scrollTo({ top: list.scrollTop + itemRect.top - listRect.top, behavior: 'smooth' });
        }
      }
    }, { threshold: [.2, .5, .8] });
    root.querySelectorAll('.product__media-item').forEach(e => mediaObserver.observe(e));
    window.addEventListener('resize', queue, { passive: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
(() => {
  let scheduled = false;
  const update = () => {
    scheduled = false;
    const root = document.querySelector('.rs-product');
    if (!root) return;
    document.body.classList.toggle('rs-page-scrolled', window.scrollY > 8);
    const header = document.querySelector('.section-header');
    if (header) document.body.style.setProperty('--rs-navigation-height', `${header.offsetHeight}px`);
    const info = root.querySelector('.product__info-container');
    const price = info?.querySelector('[id^="price-"]');
    if (info && price) root.style.setProperty('--rs-price-top', `${price.offsetTop}px`);
  };
  const queue = () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  document.addEventListener('shopify:section:load', queue);
  document.addEventListener('change', queue);
  document.fonts?.ready.then(queue);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
})();
